import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { fetchDocById, updateGolfCourseInDb } from './utils';
import Select from 'react-select';
import './login_signup.css';
import { allCountries } from 'country-region-data';

const countryStateMap = {};
allCountries.forEach(([countryName, countryCode, regions]) => {
    countryStateMap[countryName] = regions.map(region => region[0]);
});

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EditGolfCourse() {
    const query = useQuery();
    const id = query.toString().replace('?', '').replace('=', '');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [course, setCourse] = useState(null);

    const [countryListForSelect, setCountryListForSelect] = useState([]);
    const [stateListForSelect, setStateListForSelect] = useState([]);

    const [name, setName] = useState("");
    const [country, setCountry] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [website, setWebsite] = useState("");

    useEffect(() => {
        // Prepare country list with US/Canada first
        const allCountriesArr = Object.keys(countryStateMap);
        const priorityCountries = ["United States", "Canada"];
        const sortedCountries = [
            ...priorityCountries.filter(c => allCountriesArr.includes(c)),
            ...allCountriesArr.filter(c => !priorityCountries.includes(c))
        ];
        setCountryListForSelect(sortedCountries.map((c, i) => ({
            label: c,
            value: c,
            id: i
        })));
    }, []);

    useEffect(() => {
        async function fetchCourse() {
            setLoading(true);
            const doc = await fetchDocById("golfCourses", id);
            if (doc.exists) {
                const data = doc.data();
                setCourse(data);
                setName(data.name || "");
                setCountry(data.country ? { label: data.country, value: data.country } : "");
                setCity(data.city || "");
                setState(data.state ? { label: data.state, value: data.state } : "");
                setWebsite(data.website || "");
                // Set state/province options
                if (data.country && countryStateMap[data.country]) {
                    setStateListForSelect(
                        countryStateMap[data.country].map((s, i) => ({
                            label: s,
                            value: s,
                            id: i
                        }))
                    );
                }
            }
            setLoading(false);
        }
        fetchCourse();
    }, [id]);

    useEffect(() => {
        if (country && country.value && countryStateMap[country.value]) {
            setStateListForSelect(
                countryStateMap[country.value].map((s, i) => ({
                    label: s,
                    value: s,
                    id: i
                }))
            );
        } else {
            setStateListForSelect([]);
        }
        setState(""); // Reset state/province when country changes
    }, [country]);

    const handleUpdate = async () => {
        setLoading(true);
        await updateGolfCourseInDb(id, {
            name,
            country: country.value,
            city,
            state: state ? state.value : "",
            website
        });
        setLoading(false);
        navigate('/admin/listGolfCourses');
    };

    if (loading) {
        return (
            <div className="admin-login-bg">
                <div className="admin-login-card">
                    <div className="admin-login-loading">
                        <div className="admin-login-spinner"></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="admin-login-bg">
            <div className="admin-login-card" style={{ maxWidth: 500 }}>
                <h1 className="admin-login-title">Edit Golf Course</h1>
                <form className="admin-login-form" style={{ gap: "1.2rem" }}>
                    <div>
                        <label className="admin-login-label">Golf Course Name</label>
                        <input
                            className="admin-login-input"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            placeholder="Enter course name"
                        />
                    </div>
                    <div>
                        <label className="admin-login-label">City</label>
                        <input
                            className="admin-login-input"
                            value={city}
                            onChange={e => setCity(e.target.value)}
                            placeholder="Enter city"
                        />
                    </div>
                    <div>
                        <label className="admin-login-label">Country</label>
                        <Select
                            isDisabled={false}
                            isMulti={false}
                            menuPlacement='auto'
                            menuPosition='fixed'
                            options={countryListForSelect}
                            value={country}
                            onChange={setCountry}
                            placeholder="Select country"
                        />
                    </div>
                    <div>
                        <label className="admin-login-label">State / Province / Region</label>
                        <Select
                            isDisabled={!stateListForSelect.length}
                            isMulti={false}
                            menuPlacement='auto'
                            menuPosition='fixed'
                            options={stateListForSelect}
                            value={state}
                            onChange={setState}
                            placeholder={stateListForSelect.length ? "Select state/province/region" : "No options"}
                        />
                    </div>
                    <div>
                        <label className="admin-login-label">Website</label>
                        <input
                            className="admin-login-input"
                            value={website}
                            onChange={e => setWebsite(e.target.value)}
                            placeholder="Enter website URL"
                        />
                    </div>
                    <div style={{ marginTop: "1.5rem" }}>
                        <button
                            className="admin-login-btn"
                            type="button"
                            onClick={handleUpdate}
                        >
                            Save Changes
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default EditGolfCourse;